import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import ProductCatalog from "./ProductCatalog";
import TagValueCatalog from "./ProductData";

export default function ProductManagementTabs() {
  const [tab, setTab] = useState(0);

  const handleChange = (event, newValue) => setTab(newValue);

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs value={tab} onChange={handleChange} sx={{ mb: 1 }}>
        <Tab label="Tags" />
        <Tab label="Tags Types" />
      </Tabs>

      <Box sx={{ py: 2 }}>
        {tab === 0 && <TagValueCatalog />}
        {tab === 1 && <ProductCatalog />}
      </Box>
    </Box>
  );
}
